/* eslint-disable import/prefer-default-export */
import { easyPost } from './utils';


//  签到
export const getCustomPushConfig = easyPost('user.account.getAppConfig');

//  引流弹窗
export const setCustomPushConfig = easyPost('user.account.setAppConfig');

// 设置端外开关值
export const setSwitchExternal = easyPost('compliance.config.set');

// 读取端外开关值
export const getSwitchExternal = easyPost('compliance.config.get');
